// Intranet-side postMessage endpoint. Forwards the SDK tokens stashed in
// localStorage so peer Symbols origins (canvas, marketplace, preview) can
// skip per-subdomain signin. Whitelisted origins only; page has no UI.

import _wsShared from '@symbo-ls/workspace-shared'

export const sessionBridge = {
  metadata: (el) => ({ title: el.call('polyglot', 'workspace.sessionBridge.page.title') }),
  // AMBIGUOUS (left): #0f1116 has no exact gray-ramp match (gray2 #141416 is
  // close but not byte-identical) — this is a headless postMessage bridge
  // with no visible UI, so a fixed near-black regardless of theme is fine.
  background: '#0f1116',
  // white.35 measured 3.20:1 on this ground (needs 4.5) — fable.md AA sweep,
  // delegated to tickets/sonnet.md. white.45 clears the floor (4.53:1) but
  // with almost no margin; white.55 measures ~6.22:1 — still visibly dimmer
  // than a normal caption, comfortably clear, and still a fixed ink since
  // the ground above is fixed too.
  color: 'white.55',
  fontFamily: 'system-ui',
  fontSize: 'Z2',
  padding: 'A',
  text: '{{ workspace.sessionBridge.body | polyglot }}',

  // The handshake listener is DECLARED, not armed imperatively (FA503). It
  // used to be a `window.addEventListener('message', …)` fired from
  // `onRender` behind an `el.__bridgeInit` latch with no removal anywhere —
  // so every mount of this page added one more permanent window listener,
  // each keeping this element reachable from `window` forever.
  //
  // The registration moved; the POLICY did not, and it lives in ONE place —
  // shared functions/sessionBridgeResponder.js, which the canvas page and the
  // light bridge entry (bridge.html) answer with too: a foreign origin is
  // rejected before anything is read, a message of the wrong type is ignored,
  // and the answer is the ACCESS token + expiry only, never the refresh token
  // (the server rotates refresh tokens, so a copy on the peer origin signed one
  // of the two origins out on every rotation). The SDK is reached only when
  // this origin's own token must rotate first.
  onWindowMessage: (ev, el) =>
    _wsShared.functions.answerSessionBridgeRequest(ev, { getSdk: () => el?.call?.('getSDK') }),

  onRender: (el) => {
    if (el.__bridgeReady) return
    el.__bridgeReady = true
    // Parent waits for this handshake before posting its request so the
    // listener is guaranteed armed. The declared `onWindowMessage` above
    // registers when the element takes its NODE, which the framework does
    // BEFORE it runs onRender — measured, not assumed
    // (`__tests__/globalListenerLifecycle.test.js`).
    _wsShared.functions.announceSessionBridgeReady()
  }
}
